export function checkIfAuth0User(sub: string): boolean {
  return sub?.startsWith('auth0|') ?? false;
}
